import { uuid } from 'aos-helpers/src/helpers/Uuid'
import React from 'react'
import { Controller, useFormContext } from 'react-hook-form'
import { useTranslation } from 'react-i18next'

import { TaskOrTemplatePayload } from '../../../utils'
import { MaintenanceContractorRenderer } from '../detailed-forms'
import { TaskEditableListField } from '../detailed-forms/partials/TaskEditableListField'

export const TaskContractorsField = () => {
    const { t: translate } = useTranslation()
    const { control } = useFormContext<TaskOrTemplatePayload>()

    return (
        <Controller
            control={control}
            name='contractors'
            render={({ field, fieldState }) => {
                const contractorsErrors =
                    (fieldState.error as
                        | Array<{
                              name?: unknown
                              contractTime?: unknown
                              jobStart?: unknown
                              jobEnd?: unknown
                              numberOfWorkers?: unknown
                          }>
                        | undefined) || []
                return (
                    <TaskEditableListField
                        keyPrefix='tasks.form.maintenance.contractors'
                        value={field.value || []}
                        emptyItem={{ uuid: uuid() }}
                        separated
                        className='mb-3'
                        showFirstValue={false}
                        onChange={field.onChange}
                        validation={(field.value || []).map((_, index) => ({
                            isError: Object.values(contractorsErrors?.[index] ?? {}).some(Boolean),
                            errorMessage: translate('reporting.maintenance.contractors.error', {
                                ns: 'tasks',
                            }),
                        }))}
                        itemRenderer={({ item, index, onChangeItem }) => (
                            <MaintenanceContractorRenderer
                                contractor={item}
                                key={index}
                                onChange={onChangeItem}
                            />
                        )}
                    />
                )
            }}
        />
    )
}
